import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const ArrowDownIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon data-testid="arrow down icon" viewBox="0 0 8 4" {...props}>
    <path
      clipRule="evenodd"
      d="M7.0202 0.47976C7.21546 0.675022 7.21546 0.991604 7.0202 1.18687L4.35353 3.85353C4.15827 4.04879 3.84169 4.04879 3.64643 3.85353L0.97976 1.18687C0.784497 0.991604 0.784497 0.675022 0.97976 0.47976C1.17502 0.284498 1.4916 0.284498 1.68687 0.47976L3.99998 2.79287L6.31309 0.47976C6.50836 0.284497 6.82494 0.284497 7.0202 0.47976Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </Icon>
);
